<app-title-pages-component [pageData]="pageData"></app-title-pages-component>

<!-- Filtrar usuarios por cliente -->
<div class="filter-container">
  <mat-form-field appearance="outline">
    <mat-label>Filtrar por cliente</mat-label>
    <mat-select [(ngModel)]="selectedClient">
      <mat-option value="">Todos los clientes</mat-option>
      @for (client of clients; track client.id) {
        <mat-option [value]="client.id">
          {{ client.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<app-table-component
  [columns]="columnDefinitions"
  [data]="filteredUsuarios"
  [onEdit]="editUsuario"
  [onAdd]="addUsuario"
  [editMode]="showBtn"
  [onDelete]="showConfirmDeleteDialog"
  [labelForSearch]="'Buscar usuario'"
  [menu]="true"
  [options]="options"
></app-table-component>

@if(showModal){
  <app-confirm-delete-dialog
    [message]="message"
    (confirmar)="deleteUser()"
    (cancelar)="handleCancelDeleteDialog()"
  ></app-confirm-delete-dialog>
}
